import { render } from "./configmap.vue?vue&type=template&id=6a714187&scoped=true"
import script from "./configmap.vue?vue&type=script&lang=js"
export * from "./configmap.vue?vue&type=script&lang=js"

import "./configmap.vue?vue&type=style&index=0&id=6a714187&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a714187"]])

export default __exports__